
import { mapGetters } from 'vuex'
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import { Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
SwiperCore.use([Navigation, Pagination])
export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            dragXStart: 0,
            promotionItemWidth: 310,
            checkInterest: false,
        }
    },
    computed: {
        ...mapGetters({
            promotionGetter: 'cms/promotion',
        }),
        promotion() {
            return this.promotionGetter(this.$config.THEME)
        },
    },
    methods: {
        onIntersect(entries, observer) {
            const interesting = entries[0]?.isIntersecting
            if (interesting) {
                this.checkInterest = true
            }
        },
        onBack() {
            const elParent =
                document.getElementsByClassName('w-promotion-slider')
            if (!elParent || !elParent[0]) return
            const elBack =
                elParent[0].getElementsByClassName('swiper-button-prev')
            if (!elBack || !elBack[0]) return
            elBack[0].dispatchEvent(new MouseEvent('click'))
        },
        onNext() {
            const elParent =
                document.getElementsByClassName('w-promotion-slider')
            if (!elParent || !elParent[0]) return
            const elNext =
                elParent[0].getElementsByClassName('swiper-button-next')
            if (!elNext || !elNext[0]) return
            elNext[0].dispatchEvent(new MouseEvent('click'))
        },
        evtDragStart(evt) {
            this.dragXStart = evt?.clientX
        },
        evtDragEnd(evt) {
            const dragXEnd = evt?.clientX
            if (dragXEnd > this.dragXStart) {
                this.onBack()
            } else if (dragXEnd < this.dragXStart) {
                this.onNext()
            }
            this.dragXStart = 0
        },
        getPromotionContentWidth() {
            const client = process.client
            if (client) {
                // Get promotion content width when size change
                const val = this.$refs?.refPromotion?.clientWidth
                if (val) {
                    // Display only 4 card if more than that should click arrow right icon above
                    this.promotionItemWidth = Math.ceil(val / 4) - 14
                }
            } else {
                setTimeout(() => {
                    this.getPromotionContentWidth()
                }, 1000)
            }
        },
    },
}
